module.exports = __webpack_public_path__ + "img/organisasi.17a6cfb2.png";